<script>
    import TheSvgIcon from "@main/packages/TheSvgIcon";
    import BaseButton from "@main/packages/BaseButton";
    import CenterNavigationMenu from "@/components/CenterNavigationMenu";
    import PersonalNavigationMenu from "@/components/PersonalNavigationMenu";
    import TopNavigationMenu from "@/components/TopNavigationMenu";
    import LinkWithAnalytics from "@/components/LinkWithAnalytics";
    import HeaderStatusOrder from "@/components/header/HeaderStatusOrder";

    export default {
        name: "TheHeaderMobileMenu",
        components: {
            BaseButton,
            TheSvgIcon,
            LinkWithAnalytics,
            TopNavigationMenu,
            PersonalNavigationMenu,
            CenterNavigationMenu,
            HeaderStatusOrder,
        },
        props: {
            centerMenu: Array,
            topMenu: Array,
            city: String,
            phoneCallCenter: String,
        },
        methods: {
            onClick(hash) {
                this.$emit("on-click", hash);
            },
        },
    };
</script>

<template>
    <div class="the-header-mobile-menu">
        <div class="the-header-mobile-menu__top">
            <center-navigation-menu
                :menu="centerMenu"
                @on-click="onClick"
            ></center-navigation-menu>

            <personal-navigation-menu is-mobile></personal-navigation-menu>
        </div>
        <div class="the-header-mobile-menu__bottom">
            <top-navigation-menu
                :menu="topMenu"
                :city="city"
                @on-click="onClick"
            ></top-navigation-menu>

            <div class="the-header-mobile-menu__status">
                <header-status-order></header-status-order>
            </div>
        </div>

        <div class="the-header-mobile-menu__contacts">
            <link-with-analytics
                class="the-header-mobile-menu__phone"
                type="phone"
                :text="phoneCallCenter"
            ></link-with-analytics>

            <base-button
                class="the-header-mobile-menu__callback"
                variant="v1"
                size="sm"
                @click.native="$popup.show('modal-callback')"
            >
                <the-svg-icon name="callback" :size-w="16" is-common></the-svg-icon>
                Перезвоните мне
            </base-button>

            <div class="the-header-mobile-menu__time">
                <the-svg-icon name="clock" :size-w="16" is-common></the-svg-icon>
                Ежедневно 9:00–21:00 МСК
            </div>
        </div>

        <ul class="the-header-mobile-menu__links">
            <li>
                <span>Поддержка</span>
                <link-with-analytics
                    type="email"
                    text="support@zavtra.co"
                ></link-with-analytics>
            </li>
            <li>
                <span>Бесплатный звонок по России</span>
                <link-with-analytics
                    type="phone"
                    :text="phoneCallCenter"
                ></link-with-analytics>
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
    .the-header-mobile-menu {
        background-color: #fff;
    }

    .the-header-mobile-menu__top {
        padding: 24px 32px;
    }

    .the-header-mobile-menu__bottom {
        padding: 12px 32px;
        background-color: var(--service-background-color);
    }

    .the-header-mobile-menu__status {
        margin-top: 8px;
    }

    .the-header-mobile-menu__social {
        display: flex;
        padding: 10px 0;
        a {
            @include box(24px);
            margin-right: 12px;
        }
    }

    .the-header-mobile-menu__phone {
        display: block;
        margin-bottom: 8px;
        color: var(--primary-text);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        white-space: nowrap;
        @include bp($bp-desktop-sm) {
            font-size: 18px;
            line-height: 21px;
        }
    }

    .the-header-mobile-menu__callback {
        margin-bottom: 8px;
        svg {
            margin-right: 4px;
        }
    }

    .the-header-mobile-menu__time {
        display: flex;
        align-items: center;
        color: var(--secondary-text);
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        svg {
            margin-right: 4px;
        }
    }

    .the-header-mobile-menu__compare {
        display: inline-block;
        align-self: center;
        padding: 8px 0;
        color: var(--primary-text);
    }

    .the-header-mobile-menu__contacts {
        padding: 12px 32px 24px;
        background-color: var(--service-background-color);
    }

    .the-header-mobile-menu__links {
        position: relative;
        padding: 16px 32px 40px;
        background-color: var(--service-background-color);
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 16px;
            right: 16px;
            height: 1px;
            background-color: #e0e0e0;
        }
        li {
            &:not(:first-child) {
                margin-top: 16px;
            }
        }

        span {
            display: block;
            margin-bottom: 6px;
            color: var(--primary-text);
            font-size: 12px;
            font-weight: 700;
            line-height: 14px;
        }

        a {
            color: var(--info-text);
            font-size: 12px;
            line-height: 14px;
            font-weight: 700;
        }
    }
</style>
